import { render, staticRenderFns } from "./CreateView.vue?vue&type=template&id=b384e846&scoped=true&"
import script from "./CreateView.vue?vue&type=script&lang=js&"
export * from "./CreateView.vue?vue&type=script&lang=js&"
import style0 from "./CreateView.vue?vue&type=style&index=0&id=b384e846&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b384e846",
  null
  
)

export default component.exports